import { Card, Flex, Button, Switch, message } from "antd";
import { EditOutlined, EyeOutlined, MoreOutlined } from "@ant-design/icons";
import { useTenantNavigation } from "../../../hooks/useTenantNavigation.js";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { updateNotification } from "../../../services/notificationServices.js";

const NotifiactionCard = (props) => {
  const { title, description, notificationId, enabled, entitlement, spaceEntitlements, emailType, notificationType, tenantId, languageSpecific, status, getNotificationDetails, userInfo={} } = props
  const { spaceId } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [switchValue, setSwitchValue] = useState(Boolean(enabled));
  const navigate = useTenantNavigation();

  // Update switch value when enabled prop changes
  React.useEffect(() => {
    setSwitchValue(Boolean(enabled));
  }, [enabled]);

  const updateNotificationSetting = async (value) => {
    try {
      setLoading(true);
      setSwitchValue(value); // Update local state immediately for better UX
      
      // Prepare the notification data according to the API structure
      const notificationData = {
        notificationId: notificationId || "",
        spaceId: spaceId || "",
        tenantId: tenantId || "",
        notificationType: notificationType || "",
        enabled: value,
        languageSpecific: languageSpecific || {
          english: {
            subject: "",
            body: ""
          },
          japanese: {
            subject: "",
            body: ""
          }
        },
        status: status || ""
      };

      const response = await updateNotification(spaceId, notificationData);
      
      if (response.success) {
        message.success(t('Notification setting updated successfully'));
        getNotificationDetails(false);
      } else {
        message.error(response.message || 'Failed to update notification setting');
        // Revert the switch state if API call failed
        // setSwitchValue(!value);
      }
    } catch (error) {
      message.error(t('An error occurred while updating notification setting'));
      // Revert the switch state if API call failed
      // setSwitchValue(!value);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card
      style={{
        outline: "1px solid #f0f0f0",
        marginBottom: "24px",
        width: '650px',
        margin: '10px 20px 10px 0'
      }}
      title={t(title) || t(description) || notificationType}
      styles={{
        header: {
          backgroundColor: "#fff",
          minHeight: "44px",
        },
        body: {
          padding: "15px 24px",
        },
      }}
      extra={
        <Flex align="center">
          {
            (spaceEntitlements.includes(entitlement) || userInfo.isAdmin) ?
              <>                <Switch
                  checked={switchValue}
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                  loading={loading}
                  onChange={updateNotificationSetting}
                  className="custom-switch"
                />
                <Button
                  size="small"
                  icon={<EditOutlined />}
                  style={{ marginLeft: "10px" }}
                  onClick={() => {
                    // space/:spaceId/notification-center/:notificationId
                    navigate("/app/space/"+ spaceId + "/notification-center/" + notificationId + "?type=" + emailType + "&notificationType=" + notificationType );
                  }}
                ></Button>
              </>
              : <Button
                size="small"
                icon={
                  <EyeOutlined
                  />
                }
                onClick={(event) => {
                  event.preventDefault();
                  navigate("/app/space/" + spaceId + "/notification-center/" + notificationId + "?type=" + emailType);
                }}
                style={{ marginLeft: "10px" }}
              ></Button>
          }
        </Flex>
      }
    >
      <div>{t(description)}</div>
    </Card>
  );
};

const EmailTabs = ({ notifications, spaceEntitlements, emailType, getNotificationDetails, userInfo }) => {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: "50px",
        marginBottom: "20px",
        marginTop: "15px",
        // width: "50%",
        flexWrap: 'wrap'
      }}
    >
      {notifications.map((notification, index) => {
        return (
          <>
            {/* <Flex direction="row" wrap="wrap"> */}
            <NotifiactionCard key={index} {...notification} spaceEntitlements={spaceEntitlements} emailType={emailType} getNotificationDetails={getNotificationDetails} userInfo={userInfo} />
            {/* </Flex> */}
          </>
        )
      })}
    </div>
  );
};

export default EmailTabs;
